import { useEffect } from 'react';
import { APP_NAME } from '../config';

/** Sets the tab title; null means the home title. */
export function useDocumentTitle(title: string | null) {
  useEffect(() => {
    document.title = title ? `${title} · ${APP_NAME}` : `${APP_NAME} — find an album, open it in Spotify`;
  }, [title]);
}
